import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';

import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { ISimpleChanges } from '@frontend/sports/common/core/utils/simple-change';

import { ISportPick } from '../models';

@Component({
    selector: 'bs-line-switcher-dialog-sport',
    templateUrl: './line-switcher-dialog-sport.component.html',
    styleUrls: ['./line-switcher-dialog-sport.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class LineSwitcherDialogSportComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() optionGroup: EventOptionGroup;
    @Input() pick: ISportPick;
    @Input() tracking: string;

    pickInfo: { optionId: number } | null = null;

    ngOnChanges(changes: ISimpleChanges<LineSwitcherDialogSportComponent>): void {
        if (changes.pick) {
            this.pickInfo = this.pick.optionId ? { optionId: this.pick.optionId } : null;
        }
    }
}
